<template>
  <div>
    <div class="banner"></div>

    <div class="breadcrumbs">
      <span>产品服务 > {{this.$route.meta.cnName}}</span>
    </div>

    <div class="contaner">
      <!--左导航-->
      <Menubar></Menubar>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Menubar from "./Menubar";

export default {
  data() {
    return {};
  },

  mounted() {
    if (this.$route.path === "/product") {
      this.$router.push("/product/ticket");
    }
  },

  components: { Menubar }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

.banner {
  background: url(../../assets/images/product/banner.png) no-repeat center;
  background-size: cover;
  height: 40vh;
  opacity: 0.95;

  > img {
    width: 100%;
  }
}

.breadcrumbs {
  padding: 10px 0;
  padding-left: $SIZE_PAGE_MARGING;
  background-color: #f7f8f8;
  color: #666666;
  text-align: left;
}

.contaner {
  display: flex;
  flex-direction: column;
  padding: 20px $SIZE_PAGE_MARGING 0 $SIZE_PAGE_MARGING;
  text-align: justify;
}
</style>